import React, {useState} from "react";
import {Button, Modal, message} from "antd";
import {ExclamationCircleOutlined, SendOutlined} from "@ant-design/icons";
import {personalCompanySetupStatusEnums} from "constants/constants";
import {useStore} from "hooks/useStore";

export const SendToAccountingButton = ({
    courier,
    reloadCourier,
    size = "default",
    type = "primary",
    icon = true,
    block = false,
    className = ""
}) => {
    const stores = useStore();
    const [loading, setLoading] = useState(false);
    const {personalCompanySetupInfo = {}, _id: courierId} = courier || {};

    const handleSendToAccounting = () => {
        const setupStatus = personalCompanySetupInfo?.status;

        if (
            !(
                stores.meStore.checkRole("sendCourierDataToAccounting") &&
                stores.meStore.checkPermission("couriers.onboarding")
            )
        ) {
            message.error("Bu işlem için yetkiniz bulunmamaktadır.");
            return;
        }

        if (setupStatus !== personalCompanySetupStatusEnums.SUPPORT_REQUESTED) {
            Modal.confirm({
                title: "Uyarı",
                icon: <ExclamationCircleOutlined />,
                content:
                    "Şahıs şirketi kurulumu için bilgilerini iletmek istediğiniz kurye şahıs şirketi kendi kurmak istemiştir. Yine de bilgileri iletmek istiyor musunuz?",
                okText: "Evet, Gönder",
                cancelText: "Hayır",
                onOk: async () => {
                    await sendToAccounting();
                }
            });
        } else {
            Modal.confirm({
                title: "Muhasebeye Gönder",
                icon: <ExclamationCircleOutlined />,
                content: "Kurye bilgileri muhasebeye gönderilecektir. Onaylıyor musunuz?",
                okText: "Evet, Gönder",
                cancelText: "Hayır",
                onOk: async () => {
                    await sendToAccounting();
                }
            });
        }
    };

    const sendToAccounting = async () => {
        try {
            setLoading(true);
            const success = await stores.courierStore.sendCourierToAccounting(courierId);
            if (success) {
                reloadCourier?.();
            }
        } catch (error) {
            message.error(error.message || "Muhasebeye gönderim sırasında bir hata oluştu.");
        } finally {
            setLoading(false);
        }
    };

    // Eğer kurye yoksa veya zaten gönderildiyse butonu gösterme
    if (!courier || personalCompanySetupInfo?.sentToAccounting) {
        return null;
    }

    // Rol kontrolü - buton render edilmeden önce
    if (
        !(
            stores.meStore.checkRole("sendCourierDataToAccounting") &&
            stores.meStore.checkPermission("couriers.onboarding")
        )
    ) {
        return null;
    }

    return (
        <Button
            type={type}
            size={size}
            icon={icon ? <SendOutlined /> : null}
            onClick={handleSendToAccounting}
            loading={loading}
            block={block}
            className={className}
        >
            Muhasebeye Gönder
        </Button>
    );
};
